"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TOCDesignComp;
const react_1 = __importDefault(require("react"));
const toc_1 = require("./toc");
const react_2 = require("react");
const immer_1 = __importDefault(require("immer"));
const uuid_1 = __importDefault(require("uuid"));
const TOCDesignRightPane_1 = require("./TOCDesignRightPane");
const ReorderableList_1 = require("./ReorderableList");
const FillDownwardComponent_1 = __importDefault(require("@mwater/react-library/lib/FillDownwardComponent"));
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
/** Designer component for TOC */
function TOCDesignComp(props) {
    const { block, designCtx } = props;
    const blockDef = block.blockDef;
    // Select first item by default
    const [selectedId, setSelectedId] = (0, react_2.useState)(blockDef.items[0] ? blockDef.items[0].id : null);
    // Select item
    const handleItemClick = (item, ev) => {
        ev.stopPropagation();
        setSelectedId(item.id);
    };
    /** Alter items using an action */
    const alterBlockItems = (action) => {
        designCtx.store.replaceBlock((0, immer_1.default)(blockDef, (draft) => {
            draft.items = (0, toc_1.alterItems)(blockDef.items, action);
        }));
    };
    function handleSetItems(items) {
        designCtx.store.replaceBlock((0, immer_1.default)(blockDef, (draft) => {
            draft.items = items;
        }));
    }
    const handleAddItem = () => {
        designCtx.store.replaceBlock((0, immer_1.default)(blockDef, (draft) => {
            draft.items.push({
                id: (0, uuid_1.default)(),
                labelBlock: {
                    type: "text",
                    id: uuid_1.default.v4(),
                    text: { _base: designCtx.locale, [designCtx.locale]: "New Item" }
                },
                children: [],
                contextVarMap: {}
            });
        }));
    };
    const handleHeaderSet = (header) => {
        designCtx.store.replaceBlock((0, immer_1.default)(blockDef, (draft) => {
            draft.header = header;
        }));
    };
    const handleFooterSet = (footer) => {
        designCtx.store.replaceBlock((0, immer_1.default)(blockDef, (draft) => {
            draft.footer = footer;
        }));
    };
    const setItemLabelBlock = (itemId, labelBlock) => {
        alterBlockItems((item) => {
            if (item.id === itemId) {
                return { ...item, labelBlock };
            }
            return item;
        });
    };
    function handleSetChildren(itemId, children) {
        alterBlockItems((item) => {
            if (item.id === itemId) {
                return { ...item, children };
            }
            return item;
        });
    }
    const addChildItem = (itemId) => {
        alterBlockItems((item) => {
            if (item.id === itemId) {
                return (0, immer_1.default)(item, (draft) => {
                    draft.children.push({
                        id: (0, uuid_1.default)(),
                        labelBlock: {
                            type: "text",
                            id: uuid_1.default.v4(),
                            text: { _base: designCtx.locale, [designCtx.locale]: "New Item" }
                        },
                        children: []
                    });
                });
            }
            return item;
        });
    };
    const deleteItem = (itemId) => {
        alterBlockItems((item) => (item.id === itemId ? null : item));
    };
    // Render the dropdown gear menu to edit an entry
    const renderCaretMenu = (item) => {
        return (react_1.default.createElement(DropdownMenu, { items: [
                { label: "Add Subitem", onClick: () => addChildItem(item.id) },
                { label: "Delete", onClick: () => deleteItem(item.id) }
            ] }));
    };
    const renderLeft = () => {
        return (react_1.default.createElement("div", { style: { padding: 10 } },
            react_1.default.createElement(bootstrap_1.FormGroup, { label: "Header" }, designCtx.renderChildBlock(designCtx, blockDef.header, handleHeaderSet)),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: "Items", hint: "Select an item to edit it" },
                renderItems(designCtx, blockDef.items, 0, handleSetItems),
                react_1.default.createElement("button", { type: "button", className: "btn btn-link btn-sm", onClick: handleAddItem },
                    react_1.default.createElement("i", { className: "fa fa-plus" }),
                    " Add Item")),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: "Footer" }, designCtx.renderChildBlock(designCtx, blockDef.footer, handleFooterSet))));
    };
    function renderItems(designCtx, items, depth, onItemsChange) {
        return (react_1.default.createElement(ReorderableList_1.ReorderableList, { items: items, onItemsChange: onItemsChange, getItemId: (item) => item.id, renderItem: (item, index, innerRef, draggableProps, dragHandleProps) => (react_1.default.createElement("div", { ...draggableProps, ref: innerRef }, renderItem(designCtx, item, index, depth, dragHandleProps))) }));
    }
    /** Render an item at a specified depth which starts at 0 */
    function renderItem(designCtx, item, index, depth, dragHandleProps) {
        const isSelected = item.id === selectedId;
        let itemDesignCtx = designCtx;
        if (item.repeatRowsetContextVarId) {
            const repeatRowsetCV = designCtx.contextVars.find((ctx) => ctx.id === item.repeatRowsetContextVarId);
            if (repeatRowsetCV) {
                const itemRowCV = (0, toc_1.createTOCItemContextVar)(repeatRowsetCV);
                itemDesignCtx = { ...designCtx, contextVars: [...designCtx.contextVars, itemRowCV] };
            }
        }
        return react_1.default.createElement("div", { key: item.id },
            react_1.default.createElement("div", { style: {
                    display: "grid",
                    gridTemplateColumns: "auto 1fr auto",
                    alignItems: "center",
                    minHeight: "100%",
                    alignContent: "center",
                    paddingLeft: depth * 20 + 10,
                    backgroundColor: isSelected ? "#EEE" : "transparent"
                }, onClick: handleItemClick.bind(null, item) },
                react_1.default.createElement("div", { style: { cursor: "pointer" }, ...dragHandleProps },
                    react_1.default.createElement("i", { className: "fas fa-ellipsis-v text-muted", style: { opacity: 0.5, paddingTop: 5, paddingRight: 5 } })),
                itemDesignCtx.renderChildBlock(itemDesignCtx, item.labelBlock || null, setItemLabelBlock.bind(null, item.id)),
                renderCaretMenu(item)),
            item.children.length > 0 ? (react_1.default.createElement("div", { key: "children" }, renderItems(itemDesignCtx, item.children, depth + 1, handleSetChildren.bind(null, item.id)))) : null);
    }
    const renderRight = () => {
        function getSelectedItemAndDesignCtx(items, itemDesignCtx) {
            for (const item of items) {
                if (item.id === selectedId) {
                    return { item, designCtx: itemDesignCtx };
                }
                if (item.repeatRowsetContextVarId) {
                    const repeatRowsetCV = itemDesignCtx.contextVars.find((ctx) => ctx.id === item.repeatRowsetContextVarId);
                    if (repeatRowsetCV) {
                        const itemRowCV = (0, toc_1.createTOCItemContextVar)(repeatRowsetCV);
                        const subItemDesignCtx = { ...itemDesignCtx, contextVars: [...itemDesignCtx.contextVars, itemRowCV] };
                        const result = getSelectedItemAndDesignCtx(item.children, subItemDesignCtx);
                        if (result) {
                            return result;
                        }
                    }
                }
                const result = getSelectedItemAndDesignCtx(item.children, itemDesignCtx);
                if (result) {
                    return result;
                }
            }
            return null;
        }
        const result = getSelectedItemAndDesignCtx(blockDef.items, designCtx);
        if (!result) {
            return null;
        }
        return (react_1.default.createElement(TOCDesignRightPane_1.TOCDesignRightPane, { item: result.item, renderProps: result.designCtx, onItemChange: (item) => {
                alterBlockItems((draft) => {
                    if (draft.id == item.id) {
                        return item;
                    }
                    return draft;
                });
            } }));
    };
    // Render overall structure
    return (react_1.default.createElement(FillDownwardComponent_1.default, null,
        react_1.default.createElement("div", { style: {
                display: 'flex',
                height: '100%', // Adjust this based on your layout needs
                overflow: 'hidden'
            } },
            react_1.default.createElement("div", { style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: '10px',
                    borderRight: '1px solid #ccc' // Optional: adds a divider between panes
                } }, renderLeft()),
            react_1.default.createElement("div", { style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: '10px'
                } }, renderRight()))));
}
/** Drop down menu */
const DropdownMenu = (props) => {
    return (react_1.default.createElement("div", { className: "dropdown" },
        react_1.default.createElement("button", { type: "button", className: "btn btn-link btn-sm dropdown-toggle", "data-bs-toggle": "dropdown" }),
        react_1.default.createElement("ul", { className: "dropdown-menu" }, props.items.map((item, index) => {
            return (react_1.default.createElement("li", { key: index },
                react_1.default.createElement("a", { className: "dropdown-item", onClick: item.onClick }, item.label)));
        }))));
};
